import React, { useState } from 'react';
import { FlexContainer, Row, Column, Icon, Text, Hide } from '../../common';
import Filters from './Filters';

const Header = (props) => {
    const [collapsed, setCollapsed] = useState(false);
    return (
        <FlexContainer
            padding={16}
            backgroundColor='#FFFFFF'
            direction='column'
            boxShadow
            zIndex={1}
        >
            <Row>
                <Text text='Monitor de Shoppers' strong size={16} />
            </Row>
            <Row border='1px solid #eaeaea' borderRadius={4} direction='column !important'>
                <Row
                    backgroundColor='#89A503'
                    pX={16}
                    pY={10}
                    pointer
                    onClick={() => setCollapsed(!collapsed)}
                    borderRadius={!collapsed ? '4px 4px 0 0' : 4}
                    maxHeight='40px'
                >
                    <Column direction='row' align='center'>
                        <Icon name='filters' color='#FFFFFF' size={16} right={10} />
                        <Text text='Filtrar por:' strong color='#FFFFFF' size={14} />
                    </Column>
                    <Column align='flex-end' justify='center'>
                        <Icon name={collapsed ? 'chebron_down' : 'chebron_up'} color='#FFFFFF' size={12} />
                    </Column>
                </Row>
                <Hide condition={collapsed}>
                    <Filters {...props} onSubmitCallback={() => setCollapsed(true)} isMobile />
                </Hide>
            </Row>
        </FlexContainer>
    );
};

const MobileFilters = (props) => {
    return (
        <>
            <Header {...props} />
        </>
    );
};

MobileFilters.propTypes = {};

export default MobileFilters;
